import React from 'react';
import { Origin } from '../../manage-installed-apps-page';
import { MessageBoxFunctionalLayout, Modal, TextButton } from 'wix-style-react';
export var DeleteHybridAppModal = function (_a) {
    var app = _a.app, origin = _a.origin, editorUrl = _a.editorUrl, handleClose = _a.handleClose, t = _a.t;
    var title = t('manage-apps.delete-hybrid-header', {
        name: app.webSolutionBase.name,
    }).replace('&amp;', '&');
    var learnMoreTextButton = (React.createElement(TextButton, { as: "a", href: t('manage-apps.delete-hybrid-learn-more-link'), target: "_blank", onClick: handleClose }, t('manage-apps.delete-hybrid-learn-more')));
    var confirmText = origin === Origin.EDITOR
        ? t('manage-apps.delete-hybrid-editor-cta')
        : t('manage-apps.delete-hybrid-dashboard-cta');
    var onOkClick = function () {
        if (origin === Origin.BIZMGR) {
            window.open(editorUrl, '_blank');
        }
        handleClose();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxFunctionalLayout, { closeButton: true, theme: "blue", title: title, sideActions: learnMoreTextButton, confirmText: confirmText, onOk: onOkClick, onClose: handleClose, dataHook: "delete-hybrid-app-modal" },
            t('manage-apps.delete-hybrid-line1'),
            React.createElement("br", null),
            React.createElement("br", null),
            t('manage-apps.delete-hybrid-line2'),
            React.createElement("br", null),
            t('manage-apps.delete-hybrid-line3'))));
};
//# sourceMappingURL=delete-hybrid-modal.js.map